import { h } from 'vue'
import { registrarFuncao } from '@/components/base/workflow/aprovacoes/aprovacoesRegistry'
import { formatarDataBR } from '@/utils/useDataBR'
import FiltrosOrdemCompra from './FiltrosOrdemCompra.vue'
import DetalhesOrdemCompraEnxuto from './DetalhesOrdemCompraEnxuto.vue'
import DetalhesOrdemCompraCompleto from './DetalhesOrdemCompraCompleto.vue'

const formatarValor = (valor) => {
  if (valor == null) return '-'
  try {
    return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor)
  } catch (e) {
    return valor?.toFixed(2) ?? '-'
  }
}

// Renderers para slots de coluna (componentes inline)
const slotRenderers = {
  resumoAprovacao: {
    props: ['row'],
    render () {
      const texto = this.row.resumoAprovacao || '-'
      return h('span', {
        class: 'text-truncate d-inline-block',
        style: 'max-width: 200px',
        title: this.row.resumoAprovacao || ''
      }, texto)
    }
  },
  acoes: {
    props: ['row', 'abrirModal'],
    render () {
      return h('div', { class: 'd-flex justify-content-end gap-1 acoes-wrapper' }, [
        h('button', {
          class: 'btn btn-sm btn-outline-info',
          onClick: () => this.abrirModal(this.row),
          title: 'Analisar'
        }, [
          h('i', { class: 'bi bi-search me-1' }),
          ' Analisar'
        ])
      ])
    }
  }
}

const definicao = {
  chave: 'OrdemCompra',
  titulo: 'Aprovações de Ordens de Compra',
  subtitulo: 'Análise e aprovação de ordens pendentes',
  apiEndpoint: '/OrdensCompra',
  entityKey: 'idOrdemCompra',
  endpointLista: '/aprovacoes',
  endpointAprovar: '/aprovar',
  endpointReprovar: '/reprovar',
  listasTabelas: ['OrdemCompra', 'OrdemCompraItem'],
  nomeEntidade: 'ordem de compra',
  nomeEntidadeTitle: 'Ordem de Compra',

  formatarValor,

  colunas: [
    { field: 'idOrdemCompra', label: '#', width: 80, sortable: true, formatter: (v, row) => '#' + row.idOrdemCompra },
    { field: 'numeroOrdem', label: 'Nº Ordem', sortable: true, class: 'fw-medium text-body-emphasis' },
    { field: 'nomeFornecedor', label: 'Fornecedor', sortable: false },
    { field: 'dataEmissao', label: 'Emissão', align: 'center', sortable: true, formatter: (v, row) => formatarDataBR(row.dataEmissao) },
    { field: 'valorTotalMoedaPadrao', label: 'Valor Total', align: 'right', class: 'fw-medium', sortable: true, formatter: (v) => formatarValor(v) },
    { field: 'nomeGrupoAprovador', label: 'Grupo', sortable: false },
    {
      field: 'designadoDiretamente',
      label: 'Designado',
      align: 'center',
      sortable: false,
      allowHtml: true,
      formatter: (v, row) => row.designadoDiretamente
        ? '<span class="badge text-bg-info">Direto</span>'
        : '<span class="text-muted">&mdash;</span>'
    },
    { field: 'resumoAprovacao', label: 'Resumo', sortable: false, slotName: 'resumoAprovacao' },
    { field: 'acoes', label: 'Ações', width: 120, align: 'right', slotName: 'acoes', resizable: false, sortable: false }
  ],

  // Renderers para slots de coluna
  slotRenderers,

  // Componentes dos slots
  componenteFiltros: FiltrosOrdemCompra,
  componenteDetalhesEnxuto: DetalhesOrdemCompraEnxuto,
  componenteDetalhesCompleto: DetalhesOrdemCompraCompleto,

  // Mensagens do modal
  modalTitulo: 'Análise da Ordem de Compra',
  modalTamanho: 'xl',
  modalCorHeader: 'var(--bs-info)',

  // Mensagens de confirmação
  confirmacaoReprovarTitulo: 'Reprovar Ordem de Compra',
  confirmacaoReprovarMensagem: 'Tem certeza que deseja <strong>reprovar</strong> esta ordem de compra?<br><br><textarea id="observacaoReprovacao" class="form-control" rows="3" placeholder="Observação (opcional)..." style="text-align: left; font-size: 0.9rem;"></textarea>',
  confirmacaoAprovarTitulo: 'Aprovar Ordem de Compra',
  confirmacaoAprovarMensagem: 'Tem certeza que deseja <strong>aprovar</strong> esta ordem de compra?<br><br><textarea id="observacaoAprovacao" class="form-control" rows="3" placeholder="Observação (opcional)..." style="text-align: left; font-size: 0.9rem;"></textarea>',

  // Textos do grid
  emptyMessage: 'Nenhuma ordem pendente de aprovação encontrada.',
  hintMessage: 'Duplo clique na linha para analisar a ordem',

  // Filtros padrão
  filtrosPadrao: {
    buscaNumero: '',
    buscaResumo: '',
    idGrupoAprovador: null,
    faixaValor: ''
  }
}

registrarFuncao('OrdemCompra', definicao)

export default definicao
